import { render } from "./PortfolioGlimpse.vue?vue&type=template&id=5454ddc8"
import script from "./PortfolioGlimpse.vue?vue&type=script&lang=js"
export * from "./PortfolioGlimpse.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__